<template>
  <div>
    <iframe
      v-if="!isPopUp"
      title="Playable content"
      :src="src"
      class="size-full overflow-hidden"
      :width="width"
      :height="height"
    />
    <KikModal
      v-else
      :is-open="isOpen"
      @close="isOpen = false"
    >
      <template #content>
        <iframe
          title="Playable content"
          :src="src"
          class="mt-6 size-full overflow-hidden"
          :width="width"
          :height="height"
        />
      </template>
    </KikModal>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  src: string;
  height?: number;
  width?: number;
  isPopUp?: boolean;
  openAfterSeconds?: number;
}
const { src, width, height, isPopUp = false, openAfterSeconds = 0 } = defineProps<Props>();
const isOpen = ref(false);

onMounted(() => {
  setTimeout(() => {
    isOpen.value = true;
  }, openAfterSeconds * 1000);
});

useHead({
  script: [
    { src: width || height ? '' : 'https://files.cdn.leadfamly.com/campaign/sdk/utilities.responsive_iframe.min.js',
      type: 'text/javascript',
    }],
});
</script>
